{
    "NMkuH": {
        "position": {
            "x": 9,
            "y": 3,
            "z": 1
        },
        "key": "NMkuH",
        "tag": "badspawn"
    },
    "Oq5fe": {
        "position": {
            "x": 7,
            "y": 6,
            "z": 1
        },
        "key": "Oq5fe",
        "tag": "goodspawn"
    },
    "dZvrv": {
        "position": {
            "x": 8,
            "y": 6,
            "z": 1
        },
        "key": "dZvrv",
        "tag": "goodspawn"
    },
    "ciDtx": {
        "position": {
            "x": 6,
            "y": 6,
            "z": 1
        },
        "key": "ciDtx",
        "tag": "goodspawn"
    },
    "7Org2": {
        "position": {
            "x": 9,
            "y": 6,
            "z": 1
        },
        "key": "7Org2",
        "tag": "goodspawn"
    },
    "2W1Mj": {
        "position": {
            "x": 7,
            "y": 3,
            "z": 1
        },
        "key": "2W1Mj",
        "tag": "badspawn"
    },
    "tVdZ1": {
        "position": {
            "x": 8,
            "y": 3,
            "z": 1
        },
        "key": "tVdZ1",
        "tag": "badspawn"
    },
    "kQU9P": {
        "position": {
            "x": 6,
            "y": 3,
            "z": 1
        },
        "key": "kQU9P",
        "tag": "badspawn"
    },
    "Mz8jx": {
        "position": {
            "x": 10,
            "y": 3,
            "z": 1
        },
        "key": "Mz8jx",
        "tag": "badspawn"
    },
    "CLwin": {
        "position": {
            "x": 5,
            "y": 3,
            "z": 1
        },
        "key": "CLwin",
        "tag": "badspawn"
    }
}